import {
    COOKIE_NAME_USE_NATIVE_ONLINE_TICKETING,
    SEARCH_PARAM_NAME_NATIVE_ONLINE_TICKETING
} from '@/helpers/feature-flags.const';
import { cookieStorage } from '@cineamo/ui/src/helpers/cookie-helper';

export const getOnlineTicketingLinkFlag = (searchParams: string): boolean => {
    const _searchParams = new URLSearchParams(searchParams);
    if (_searchParams.get(SEARCH_PARAM_NAME_NATIVE_ONLINE_TICKETING) === 'true') {
        cookieStorage.setItem(COOKIE_NAME_USE_NATIVE_ONLINE_TICKETING, true);
        return true;
    } else if (_searchParams.get(SEARCH_PARAM_NAME_NATIVE_ONLINE_TICKETING) === 'false') {
        cookieStorage.removeItem(COOKIE_NAME_USE_NATIVE_ONLINE_TICKETING);
        return false;
    }
    if (!cookieStorage.getItem(COOKIE_NAME_USE_NATIVE_ONLINE_TICKETING)) return false;
    return cookieStorage.getItem(COOKIE_NAME_USE_NATIVE_ONLINE_TICKETING) === true;
};
